// Get the button:
let blockForHide = document.querySelector('.hideToScrollBottom');

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (window.innerWidth > 1140) {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      blockForHide.classList.add('hide');
    } else {
      blockForHide.classList.remove('hide');
    }
  }
}
